import type { SessionLmsAction } from "@simbelapp/order-sdk";
import { useSessionDetailsStore } from "~/store/sessions/session-details-store";

export const useSessionLmsRules = () => {
  const sessionDetailsStore = useSessionDetailsStore();

  function isLmsActionDisabled(ruleName: SessionLmsAction): boolean {
    if (!sessionDetailsStore.sessionDetails?.isExternalLms) return false;
    if (!sessionDetailsStore.lmsRules) return true;
    return !sessionDetailsStore.lmsRules[ruleName];
  }

  return { isLmsActionDisabled };
};
